/**
 * Translation (spec §4, §15; ADR-0014; remediation pass 12).
 *
 * The English text is the key. A catalogue maps it to another language; a
 * string with no entry is shown in English rather than as a key, so a gap is
 * visible and never blank. Values carry `{name}` placeholders, filled from
 * `vars`, so a sentence keeps its own word order in each language.
 *
 * The Arabic catalogue was written by the build team and is **pending
 * Algihaz's review** (OPEN_QUESTIONS Q30). Wording is corrected there, as data.
 */
export function translate(catalogue, text, vars) {
    const template = (catalogue && catalogue[text]) || text;
    if (!vars)
        return template;
    return template.replace(/\{(\w+)\}/g, (whole, key) => {
        const value = vars[key];
        return value === undefined || value === null ? whole : String(value);
    });
}
const patterns = new WeakMap();
function compiled(catalogue) {
    let list = patterns.get(catalogue);
    if (!list) {
        list = Object.keys(catalogue)
            .filter((key) => /\{\w+\}/.test(key))
            .map((key) => {
            const names = [];
            const source = key
                .split(/(\{\w+\})/)
                .map((part) => {
                const name = /^\{(\w+)\}$/.exec(part)?.[1];
                if (name) {
                    names.push(name);
                    return '(.+?)';
                }
                return part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            })
                .join('');
            return { regex: new RegExp(`^${source}$`, 's'), names, key };
        })
            // The most specific pattern first: the one with the most fixed text.
            .sort((a, b) => b.key.replace(/\{\w+\}/g, '').length - a.key.replace(/\{\w+\}/g, '').length);
        patterns.set(catalogue, list);
    }
    return list;
}
/**
 * A finished sentence — a server message, say — in another language. An exact
 * entry wins; otherwise a patterned one (`"Your roles do not allow {0} in {1}."`)
 * whose fixed words match, with each filled-in part translated in turn. A
 * sentence nothing matches comes back unchanged.
 */
export function translateText(catalogue, text) {
    if (!catalogue || !text)
        return text;
    const exact = catalogue[text];
    if (exact)
        return exact;
    for (const { regex, names, key } of compiled(catalogue)) {
        const match = regex.exec(text);
        if (!match)
            continue;
        const vars = {};
        names.forEach((name, index) => {
            const part = match[index + 1] ?? '';
            vars[name] = catalogue[part] ?? part;
        });
        return translate(catalogue, key, vars);
    }
    return text;
}
//# sourceMappingURL=translate.js.map